import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo, useRef } from 'react';
import useViewbox from '../../useViewbox.js';
const SvgClose = memo((componentProps) => {
    const ref = useRef(null);
    useViewbox(ref);
    const props = {
        ...componentProps,
        ref,
        className: 'spriteIcon'
    };
    return (_jsx("svg", { fill: "currentColor", role: "presentation", viewBox: "0 0 8 8", ...props, children: _jsx("path", { d: "m4 4.708 3.145 3.146a.501.501 0 0 0 .708-.708l-3.145-3.146 3.145-3.145a.5.5 0 1 0 -.708-.708l-3.145 3.145-3.146-3.145a.5.5 0 1 0 -.708.708l3.146 3.145-3.145 3.145a.5.5 0 0 0 .707.708z", fill: "currentColor" }) }));
});
export default SvgClose;
//# sourceMappingURL=Close.js.map